import { render, staticRenderFns } from "./TestModelGroupModal.vue?vue&type=template&id=4e809cf6&"
import script from "./TestModelGroupModal.vue?vue&type=script&lang=js&"
export * from "./TestModelGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports